import React, { useEffect, useState, useCallback } from "react";

import Header from "./header";
import { LOGIN, CUSTOMER_INFO } from "../const/mount_list";

function Router() {
  const [mountTarget, setMountTarget] = useState(CUSTOMER_INFO);
  const [mountProps, setMountProps] = useState({});
  const [render, updateParent] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [accountName, setAccountName] = useState("");
  const [accountId, setAccountId] = useState("");

  const loggedIn = useCallback(() => {
    return !!accountName;
  }, [accountName]);

  useEffect(() => {
    if (!loggedIn()) {
      setMountTarget(LOGIN);
    }
    window.scrollTo(0, 0);
  }, [render, loggedIn]);

  // MEMO: IE9に対応させるためReactRouterを廃止し、子componentのmount/unmountにて対応する
  return (
    <>
      {loggedIn() ? (
        <Header
          subtitle={subtitle}
          updateParent={updateParent}
          setMountTarget={setMountTarget}
          accountName={accountName}
          setAccountName={setAccountName}
          setAccountId={setAccountId}
        />
      ) : (
        ""
      )}
      {React.cloneElement(mountTarget, {
        setMountTarget,
        setMountProps,
        updateParent,
        setSubtitle,
        setAccountName,
        setAccountId,
        accountId,
        ...mountProps
      })}
    </>
  );
}

export default Router;
